



























































































import { cloneDeep } from 'lodash'
import { Vue, Component, Prop, VModel, Watch } from 'vue-property-decorator'

import { createReplicatorItem, processReplicatorItemsForOutput } from './helpers'
import { ReplicatorItem, ComponentData } from './types'

@Component
export default class Replicator extends Vue {
  @VModel({ type: Array }) model!: Array<any>

  @Prop({ required: true }) readonly componentData!: ComponentData

  @Prop({ required: true }) readonly defaultDataStructure!: any

  @Prop({ default: 12 }) readonly maxItemsLength!: any

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: String }) readonly addItemTitle!: string | undefined

  activeIndex = 0

  @Watch('activeIndex')
  onActiveIndexChange(idx: number): void {
    this.$emit('activeTabIndex', idx)
  }

  replicatorModel: Array<ReplicatorItem> = []

  createItem(): void {
    if (this.replicatorModel.length < this.maxItemsLength) {
      this.replicatorModel.push(createReplicatorItem(cloneDeep(this.defaultDataStructure)))
      this.activeIndex = this.replicatorModel.length - 1
    }
  }

  deleteItem(): void {
    this.replicatorModel.splice(this.activeIndex, 1)

    if (this.activeIndex !== 0) {
      this.activeIndex--
    }
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      replicator_add_item: 'Добавить элемент',
    })
    this.$i18n.mergeLocaleMessage('en', {
      replicator_add_item: 'Add item',
    })

    // eslint-disable-next-line id-blacklist
    this.replicatorModel = this.model.map((item: any) => createReplicatorItem(item))

    this.$watch('replicatorModel', (updatedReplicatorModel) => {
      this.model = processReplicatorItemsForOutput(updatedReplicatorModel)
    }, { deep: true })
  }
}
